module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "component-create-plan"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "columns"
  }, [_c('label', [_vm._v("Name"), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.attribute.name),
      expression: "attribute.name"
    }],
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.attribute.name)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.attribute, "name", $event.target.value)
      }
    }
  })])]), _c('div', {
    staticClass: "columns"
  }, [_c('label', [_vm._v("Description")]), (_vm.$route.params.hasOwnProperty('id')) ? [_c('TranslateField', {
    attrs: {
      "group": "entities",
      "field": _vm.attribute._translatable.description,
      "label": "Description",
      "value": _vm.attribute.description
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.attribute.description),
      expression: "attribute.description"
    }],
    staticClass: "input-group-field",
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.attribute.description)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.attribute, "description", $event.target.value)
      }
    }
  })])] : [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.attribute.description),
      expression: "attribute.description"
    }],
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.attribute.description)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.attribute, "description", $event.target.value)
      }
    }
  })]], 2)]), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "columns small-12 large-6"
  }, [_c('label', [_vm._v("Type"), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.attribute.type),
      expression: "attribute.type"
    }],
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.attribute, "type", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, [_c('option', [_vm._v("number")]), _c('option', [_vm._v("string")])])]), _c('label', [_vm._v("Recommended  "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.attribute.recommended),
      expression: "attribute.recommended"
    }],
    attrs: {
      "type": "checkbox"
    },
    domProps: {
      "checked": Array.isArray(_vm.attribute.recommended) ? _vm._i(_vm.attribute.recommended, null) > -1 : (_vm.attribute.recommended)
    },
    on: {
      "change": function($event) {
        var $$a = _vm.attribute.recommended,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.$set(_vm.attribute, "recommended", $$a.concat([$$v])))
          } else {
            $$i > -1 && (_vm.$set(_vm.attribute, "recommended", $$a.slice(0, $$i).concat($$a.slice($$i + 1))))
          }
        } else {
          _vm.$set(_vm.attribute, "recommended", $$c)
        }
      }
    }
  })]), _c('label', [_vm._v("Private  "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.attribute.private),
      expression: "attribute.private"
    }],
    attrs: {
      "type": "checkbox"
    },
    domProps: {
      "checked": Array.isArray(_vm.attribute.private) ? _vm._i(_vm.attribute.private, null) > -1 : (_vm.attribute.private)
    },
    on: {
      "change": function($event) {
        var $$a = _vm.attribute.private,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.$set(_vm.attribute, "private", $$a.concat([$$v])))
          } else {
            $$i > -1 && (_vm.$set(_vm.attribute, "private", $$a.slice(0, $$i).concat($$a.slice($$i + 1))))
          }
        } else {
          _vm.$set(_vm.attribute, "private", $$c)
        }
      }
    }
  })])]), _c('div', {
    staticClass: "columns small-12 large-6"
  }, [_c('label', [_vm._v("Vehicle type")]), _c('SelectizeVehicleType', {
    attrs: {
      "selectedValue": _vm.attribute.vehicle_type_id
    },
    on: {
      "optionSelected": _vm.setVehicleType
    }
  }), _c('label', [_vm._v("Icon")]), _c('SelectizeIcon', {
    attrs: {
      "value-field": "iconName"
    },
    model: {
      value: (_vm.attribute.icon),
      callback: function($$v) {
        _vm.$set(_vm.attribute, "icon", $$v)
      },
      expression: "attribute.icon"
    }
  })], 1), _c('div', {
    staticClass: "row columns"
  }, [_c('button', {
    staticClass: "button",
    on: {
      "click": _vm.createAttribute
    }
  }, [_vm._v("Save")])])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-5a567e39!./~/vue-loader/lib/template-loader.js?raw&engine=pug!./~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/backoffice/CreateVehicleAttribute.vue
// module id = 2525
// module chunks = 1